var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2187_42688)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 5.70312,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 5.70312,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint0_radial_2187_42688)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 5.70312,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint1_radial_2187_42688)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.37488,
    y: 5.0077,
    width: 30.5989,
    height: 30.5989,
    rx: 15.2994,
    stroke: "white",
    strokeWidth: 1.39086
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_42688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9808 19.7969C24.7239 19.7961 24.4693 19.8464 24.232 19.9448C23.9946 20.0432 23.7792 20.1878 23.5981 20.3701L20.7295 23.2387C20.5472 23.4198 20.4027 23.6353 20.3043 23.8726C20.2059 24.11 20.1556 24.3645 20.1563 24.6214C20.1569 25.1399 20.3632 25.637 20.7299 26.0037C21.0965 26.3703 21.5936 26.5766 22.1122 26.5773C22.3692 26.578 22.6238 26.5277 22.8612 26.4293C23.0986 26.3309 23.3142 26.1864 23.4954 26.0041L26.3635 23.136C26.5457 22.9548 26.6902 22.7392 26.7886 22.5018C26.887 22.2644 26.9373 22.0098 26.9367 21.7528C26.936 21.2343 26.7297 20.7372 26.3631 20.3705C25.9964 20.0039 25.4993 19.7976 24.9808 19.7969ZM22.7573 25.2666C22.5852 25.4392 22.3562 25.5342 22.1122 25.5342C21.6088 25.5342 21.1994 25.1247 21.1994 24.6214C21.1994 24.3778 21.2943 24.1484 21.467 23.9762L22.5325 22.9107L23.8234 24.2016L22.7573 25.2666ZM25.626 22.398L24.5604 23.4635L23.27 22.1732L24.3361 21.1071C24.5077 20.935 24.7367 20.84 24.9808 20.84C25.4841 20.84 25.8935 21.2495 25.8935 21.7528C25.8935 21.9964 25.7986 22.2258 25.626 22.398Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7161 16.1332V15.4812C21.7161 14.6884 21.0745 14.0469 20.2817 14.0469H17.4131C16.6203 14.0469 15.9788 14.6884 15.9788 15.4812V16.1332C15.1182 16.1332 14.4141 16.8373 14.4141 17.6979V23.9567C14.4141 24.8173 15.1182 25.5215 15.9788 25.5215H19.249C19.1551 25.2346 19.1082 24.9269 19.1082 24.6087C19.1082 24.567 19.1082 24.52 19.1134 24.4783H15.9788C15.6919 24.4783 15.4572 24.2436 15.4572 23.9567V22.9136H18.1955C18.9882 22.9136 19.6298 22.2721 19.6298 21.4793V20.1753C19.6298 19.3826 18.9882 18.741 18.1955 18.741H15.4572V17.6979C15.4572 17.411 15.6919 17.1763 15.9788 17.1763H21.7161C22.0029 17.1763 22.2376 17.411 22.2376 17.6979V20.2327L22.8531 19.6173C22.9835 19.4869 23.1295 19.3669 23.2808 19.2626V17.6979C23.2808 16.8373 22.5767 16.1332 21.7161 16.1332Z",
    fill: "#516CD3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2187_42688",
    x: 0.507115,
    y: 0.139927,
    width: 40.3373,
    height: 40.3373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08629
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2187_42688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2187_42688",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2187_42688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.778 11.7881) rotate(51.0441) scale(24.5185 24.5185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2187_42688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2772 31.2601) rotate(-93.6705) scale(24.9998 27.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516CD3",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_42688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5177,
    height: 12.5177,
    fill: "white",
    transform: "translate(14.4141 14.0469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/Medication.6014405a5fc2059cb285809bdf6da5fc.svg";
export { ForwardRef as ReactComponent };